import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Switch from "./Switch";
import Switch1xbet from "./Switch1xbet";

function SwitchIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Switch1xbet {...props} /> : <Switch {...props} />;
}

export default SwitchIndex;
